import { Integrations } from '@sentry/tracing';
import * as Sentry from '@sentry/vue';
import { boot } from 'quasar/wrappers';

export default boot(({ app, router }) => {
  if (process.env.PROD) {
    Sentry.init({
      app,
      dsn: process.env.SENTRY_DSN,
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
      ],
      tracesSampleRate: 1.0,
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications.',
      ],
    });
  }
});
